import {
  ApprovalStepState,
  ApprovalStepStatus,
  ProposalAgent,
} from '~/data/proposals';

type PropsType = {
  step: ApprovalStepState;
  loggedUserAgency?: ProposalAgent;
  substituteAsUltimateApprover?: boolean;
};

export const useProcessApprovalStep = (props: PropsType) => {
  const { step, loggedUserAgency, substituteAsUltimateApprover } = props;

  const isUpdated = step.updatedBy.userId !== 0;
  const isPending = step.state === ApprovalStepStatus.PENDING;

  const multipleApprovers = step.approvers.length > 1;
  const approverIds = step.approvers.map((u) => u.userId);

  const isUser = {
    requestedApprover:
      !!loggedUserAgency && approverIds.includes(loggedUserAgency.userId),
    substituteApprover:
      !!loggedUserAgency && !approverIds.includes(loggedUserAgency.userId),
  };

  const decisionBySubstitute =
    !isPending && !approverIds.includes(step.updatedBy.userId);

  const showApprovers =
    isPending || (!isPending && multipleApprovers) || decisionBySubstitute;

  return {
    state: {
      isUpdated,
      isPending,
      decisionBySubstitute,
    },
    userCanDecide: {
      asRequested: isPending && isUser.requestedApprover,
      asSubstitute:
        isPending && !substituteAsUltimateApprover && isUser.substituteApprover,
      asUltimate:
        isPending &&
        !!substituteAsUltimateApprover &&
        isUser.substituteApprover,
    },
    showApprovers,
  };
};
